import {
  RugbyUnionEventStatusId,
  RugbyUnionIncidentId,
} from '@collector/sportsapi-client-legacy'

import { ManualAddIncidentConfig } from '../../../configuration'

export const manualAddIncidentConfig: ManualAddIncidentConfig<
  RugbyUnionIncidentId,
  RugbyUnionEventStatusId
> = {
  getKeyIncidents: () => [
    RugbyUnionIncidentId.Try,
    RugbyUnionIncidentId.PenaltyTry,
    RugbyUnionIncidentId.ConversionGoal,
    RugbyUnionIncidentId.ConversionMissed,
    RugbyUnionIncidentId.ConversionAttempt,
    RugbyUnionIncidentId.PenaltyKickGoal,
    RugbyUnionIncidentId.PenaltyKickMissed,
    RugbyUnionIncidentId.PenaltyAwarded,
    RugbyUnionIncidentId.DropGoal,
    RugbyUnionIncidentId.DropGoalMissed,
    RugbyUnionIncidentId.YellowCard,
    RugbyUnionIncidentId.RedCard,
    RugbyUnionIncidentId.OrangeCard,
    RugbyUnionIncidentId.SubstitutionIn,
  ],
  otherIncidents: [
    RugbyUnionIncidentId.FreeKick,
    RugbyUnionIncidentId.EntryInto22,
    RugbyUnionIncidentId.Kick,
    RugbyUnionIncidentId.GoallineDropout,
    RugbyUnionIncidentId.Offload,
    RugbyUnionIncidentId.Turnover,
    RugbyUnionIncidentId.Foul,
    RugbyUnionIncidentId.Ruck,
    RugbyUnionIncidentId.Maul,
    RugbyUnionIncidentId.Scrum,
    RugbyUnionIncidentId.Lineout,
  ],
  eventStatuses: [
    RugbyUnionEventStatusId.FirstHalf,
    RugbyUnionEventStatusId.SecondHalf,
    RugbyUnionEventStatusId.Halftime,
    RugbyUnionEventStatusId.WaitingForExtratime,
    RugbyUnionEventStatusId.ExtratimeFirstHalf,
    RugbyUnionEventStatusId.ExtratimeSecondHalf,
    RugbyUnionEventStatusId.ExtratimeHalftime,
    RugbyUnionEventStatusId.Penalties,
  ],
  layouts: {
    keyIncidentsLayout: {
      containerClass:
        'grid grid-flow-row grid-cols-2 @md:grid-cols-3 @lg:grid-cols-5 gap-1',
      buttonClass: '@lg:w-45!',
    },
    otherIncidentsLayout: {
      containerClass:
        'grid grid-flow-row grid-cols-2 @md:grid-cols-3 @lg:grid-cols-5 gap-1',
      buttonClass: '@lg:w-45!',
    },
    eventStatusesLayout: {
      containerClass:
        'grid grid-flow-row grid-cols-2 @md:grid-cols-3 @lg:grid-cols-5 gap-1',
      buttonClass: '@lg:w-45!',
    },
  },
}
